import {router} from "@/router/index.js";
import store from "@/store/index.js";
import request from '@/utils/request.js'
import setting from '@/settings.js'
import {ElMessage} from "element-plus";

const dict = {
    namespaced:true,
    state: {

    },
    getters: {
    },
    mutations: {

    },
    actions: {
        config: async (context, data) => {
          return  await request.post(setting.api.DICT,data).then(res=>{
               //console.log('-----data：',data);
               if(res.code === 0){
                   return res.data;
               }else{
                  return  null
               }
           });
        }

    }
}

export default dict;